import { Settings } from '@streamr/tv-engine';
import { isMobileDevice } from '../../../utils/canvasResolution';
const AFTER = new Set(['after', 'off', '0']);
const LIVE = new Set(['live', 'on', '1']);
export function resolveRecordingUploadOptions(input) {
    const device = {
        spoolMaxBytes: input.isMobile
            ? Settings.recordingSpoolMaxBytesMobile
            : Settings.recordingSpoolMaxBytes,
    };
    const live = Math.max(Settings.recordingLiveUploadBps, Settings.recordingLiveUploadBpsMobile);
    const param = new URLSearchParams(input.search).get('recordingUpload');
    for (const [value, source] of [
        [param, 'url'],
        [input.localStorageValue, 'storage'],
    ]) {
        if (value !== null && AFTER.has(value)) {
            return { ...device, liveUploadBps: 0, source };
        }
        if (value !== null && LIVE.has(value)) {
            return { ...device, liveUploadBps: live, source };
        }
    }
    return {
        ...device,
        liveUploadBps: input.isMobile
            ? Settings.recordingLiveUploadBpsMobile
            : Settings.recordingLiveUploadBps,
        source: input.isMobile ? 'mobile' : 'setting',
    };
}
/** Browser entry point: page URL + localStorage + device class. */
export function readRecordingUploadOptions() {
    let search = '';
    let localStorageValue = null;
    try {
        search = window.location.search;
        localStorageValue = window.localStorage.getItem('recordingUpload');
    }
    catch {
        // no window / storage access: defaults
    }
    return resolveRecordingUploadOptions({
        search,
        localStorageValue,
        isMobile: isMobileDevice(),
    });
}
